import { useQuery } from '@tanstack/react-query';
import { getCustomSurveyByUUID } from '../../api/customSurveys';

export enum GetCustomSurveyByUUIDCacheKey {
  CustomSurveyByUUID = 'customSurveyByUUID',
}

export const useGetCustomSurveyByUUIDQuery = (uuid: string) => {
  return useQuery({
    queryKey: [GetCustomSurveyByUUIDCacheKey.CustomSurveyByUUID, uuid],
    queryFn: () => getCustomSurveyByUUID(uuid),
    enabled: Boolean(uuid),
  });
};
